import React from 'react';
import { Link } from 'react-router-dom';
// Constants
import {
  CompanyTagLine,
  CompanyName,
  CompanyPhoneNumber,
  CompanyEmailAddress,
} from '../../utils/Constants';
// Components
import FooterSocialCTA from './FooterSocialCTA';
// Images
// Data
import { FooterLinksArray } from '../../utils/data/FooterData';
import { MainServicesArray } from '../../utils/data/CompanyData';

function FooterComponent() {
  return (
    <footer className='grid bg-colour2 text-colour1 w-full overflow-hidden font-poppins z-10'>
      <div className='grid mx-auto gap-6 px-2 md:px-10 py-8 w-full'>
        {/* Logo section */}
        <section className='grid h-fit my-auto gap-y-2 py-2 w-full'>
          <div className='grid items-center justify-center'>
            <span className='text-4xl uppercase'>{CompanyName}</span>
          </div>
          <div className='text-center'>
            <p className='text-sm'>{CompanyTagLine}</p>
          </div>
          <FooterSocialCTA />
        </section>

        {/* Footer links */}
        <section className='grid px-2 gap-2 w-full'>
          <ul className='grid grid-flow-col w-fit mx-auto gap-x-2 lg:gap-x-4'>
            {FooterLinksArray.map((link, index) => {
              return (
                <li key={index}>
                  <Link
                    to={link.route}
                    aria-label={`${link.name} page navigation tab`}
                    className={`text-sm md:text-base lg:text-lg`}
                    onClick={() => {
                      window.scroll(0, 0);
                    }}
                    aria-current={({ isActive }) =>
                      isActive ? 'page' : undefined
                    }
                  >
                    {link.name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </section>
      </div>
    </footer>
  );
}

export default FooterComponent;
